/**
 * Updates the active proxy for the given workspace.
 *
 * @param workspace - The workspace to update
 * @param payload - The new active proxy value
 */
export const updateActiveProxy = (workspace, payload) => {
    // If workspace is null, exit early
    if (!workspace) {
        return;
    }
    // Set or clear the active proxy in the workspace object
    workspace['x-scalar-active-proxy'] = payload;
};
/**
 * Updates the color mode for the given workspace.
 *
 * @param workspace - The workspace to update
 * @param payload - The new color mode value
 */
export const updateColorMode = (workspace, payload) => {
    // If workspace is null, do nothing
    if (!workspace) {
        return;
    }
    // Set the color mode in the workspace object
    workspace['x-scalar-color-mode'] = payload;
};
/**
 * Updates the theme for the given workspace.
 *
 * @param workspace - The workspace to update
 * @param payload - The new theme value
 */
export const updateTheme = (workspace, payload) => {
    // If workspace is null, exit early
    if (!workspace) {
        return;
    }
    // Set the theme in the workspace object
    workspace['x-scalar-theme'] = payload;
};
/**
 * Updates the active environment for the given workspace.
 *
 * @param workspace - The workspace to update
 * @param payload - The new active environment value
 */
export const updateActiveEnvironment = (workspace, payload) => {
    // If workspace is null, exit early
    if (!workspace) {
        return;
    }
    // Set the active environment in the workspace object
    workspace['x-scalar-active-environment'] = payload ?? undefined;
};
/**
 * Updates the selected http client on the workspace
 *
 * @param workspace - The workspace to update the selected http client in
 * @param payload - The payload to update the selected client with
 * @returns
 */
export const updateSelectedClient = (workspace, payload) => {
    if (!workspace) {
        return;
    }
    workspace['x-scalar-default-client'] = payload;
};
/**
 * Updates the selected example on the workspace
 *
 * @param workspace - The workspace to update the selected example in
 * @param payload - The example key to select across the document
 */
export const updateSelectedExample = (workspace, payload) => {
    if (!workspace) {
        return;
    }
    workspace['x-scalar-default-example'] = payload;
};
export const workspaceMutatorsFactory = ({ workspace }) => {
    return {
        updateActiveProxy: (payload) => updateActiveProxy(workspace, payload),
        updateColorMode: (payload) => updateColorMode(workspace, payload),
        updateTheme: (payload) => updateTheme(workspace, payload),
        updateSelectedClient: (payload) => updateSelectedClient(workspace, payload),
        updateSelectedExample: (payload) => updateSelectedExample(workspace, payload),
        updateActiveEnvironment: (payload) => updateActiveEnvironment(workspace, payload),
    };
};
